import React, { useState, useMemo } from 'react';
import {
  Box,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  ListSubheader,
  TextField,
  InputAdornment,
  styled,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';

const containsText = (text, searchText) => text.toLowerCase().indexOf(searchText.toLowerCase()) > -1;

const RemoveButton = styled('div')({
  position: 'absolute',
  right: '30px',
  cursor: 'pointer',
  top: '16px',
  color: '#2065d1',
});
const SearchSelect = ({ value, onChange, options, sx, id, label, searchPlaceholder }) => {
  const [searchText, setSearchText] = useState('');
  const displayedOptions = useMemo(
    () => options.filter((option) => containsText(option?.contactPerson, searchText)),
    [searchText]
  );

  return (
    <Box sx={sx}>
      <FormControl fullWidth>
        <InputLabel id={id}>{label}</InputLabel>
        <Select
          // Disables auto focus on MenuItems and allows TextField to be in focus
          MenuProps={{ autoFocus: false }}
          labelId="search-select-label"
          id={id}
          value={value}
          label={label}
          onChange={(e) => onChange(e.target.value)}
          onClose={() => setSearchText('')}
          // This prevents rendering empty string in Select's value
          // if search text would exclude currently selected option.
          renderValue={() => value}
        >
          <ListSubheader>
            <TextField
              size="small"
              // Autofocus on textfield
              autoFocus
              placeholder={searchPlaceholder}
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              onChange={(e) => setSearchText(e.target.value)}
              onKeyDown={(e) => {
                if (e.key !== 'Escape') {
                  // Prevents autoselecting item while typing (default Select behaviour)
                  e.stopPropagation();
                }
              }}
            />
          </ListSubheader>
          {displayedOptions.map((option, i) => (
            <MenuItem key={i} value={option?.id}>
              {option?.contactPerson}
            </MenuItem>
          ))}
        </Select>
        {value.length > 0 ? (
          <RemoveButton onClick={() => onChange('')}>
            <CloseIcon />
          </RemoveButton>
        ) : null}
      </FormControl>
    </Box>
  );
};

export default SearchSelect;
